module.exports = __webpack_public_path__ + "static/media/English.e48de935.gif";